import { useEffect, useState } from "react";

// Shopper wishlist kept in the browser — no account needed on the public site
const KEY = "brioni-wishlist";
const EVT = "brioni-wishlist-change";

export const readWishlist = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 40)));
  window.dispatchEvent(new Event(EVT));
};

export const toggleWishlist = (entry) => {
  const list = readWishlist();
  const on = list.some((w) => w.id === entry.id);
  write(
    on
      ? list.filter((w) => w.id !== entry.id)
      : [...list, { ...entry, at: Date.now() }],
  );
  return !on;
};

export const removeWishlist = (id) =>
  write(readWishlist().filter((w) => w.id !== id));

export const clearWishlist = () => write([]);

export function useWishlist() {
  const [list, setList] = useState(readWishlist);
  useEffect(() => {
    const sync = () => setList(readWishlist());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return list;
}
